import { type CSSProperties, PureComponent } from "react";

import { ActionIconButton, ActionIconButtonType } from "~/common/components/Button/ActionIconButton";
import { type WithTranslation } from "react-i18next";
import { withTranslation as withTranslationBase } from "react-i18next";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

interface SalesmanDetailsToggleProps extends WithTranslation {
  className?: string;
  style?: CSSProperties;
  checked?: boolean;
  onCheck?: (newVal: boolean) => void;
  "data-test-id"?: string;
}

class SalesmanDetailsToggle extends PureComponent<SalesmanDetailsToggleProps> {
  toggle = () => {
    if (this.props.onCheck) {
      this.props.onCheck(!this.props.checked);
    }
  };

  render() {
    const { checked, className, ...rest } = this.props;
    const cls = `d-flex flex-align-center ${className ? className : ""}`;

    const icon = checked ? <VisibilityIcon  /> : <VisibilityOffIcon  />;

    return (
      <ActionIconButton
        // data-test-id={"active-quote-toggle-details"}
        className={cls}
        onIconClick={this.toggle}
        icon={icon}
        clickableType={ActionIconButtonType.PRIMARY}
        {...rest}
      />
    );
  }
}

export default withTranslationBase()(SalesmanDetailsToggle);
